import React from 'react';
import PropTypes from 'prop-types';
/**
 * 버튼 : 아이콘:이미지
 */
const domainUrlParam = process.env.REACT_APP_DOMAIN_URL;

const ImageIconButton = ({ imgUrl, styleDef, viewStatus, clickEvt, error, label, tabIndex, imgWidth, imgHeight }) => {
  const handleOnKeyPress = e => {
    if (e.key === 'Enter') {
      clickEvt();
    }
  };

  return (
    <div className="_at_icon_button_div" style={styleDef}>
      {viewStatus === '_dim' ? <div className="_dim" /> : ''}
      <div className="_button_div" role="button" tabIndex={tabIndex} onClick={clickEvt} onKeyPress={handleOnKeyPress}>
        <div className="_icon">
          <img src={imgUrl} alt={label} style={{ width: imgWidth, height: imgHeight }} />
        </div>
      </div>
    </div>
  );
};

ImageIconButton.propTypes = {
  imgUrl: PropTypes.string,
  styleDef: PropTypes.object,
  viewStatus: PropTypes.string,
  clickEvt: PropTypes.func,
  error: PropTypes.object,
  label: PropTypes.string,
  tabIndex: PropTypes.string,
  imgWidth: PropTypes.string,
  imgHeight: PropTypes.string,
};

ImageIconButton.defaultProps = {
  imgUrl: `/${domainUrlParam}/ibricks/images/btn_menu2.png`,
  styleDef: {},
  viewStatus: '',
  clickEvt: () => {},
  error: { error: false, msg: '' },
  label: '',
  tabIndex: '0',
  imgWidth: '',
  imgHeight: '',
};

export default ImageIconButton;
